import React from "react";
import CustomHeroCard from "../MsUiComponents/CustomHeroCard";
import FileUploadCard from "./FileUploadExtension/FileUploadCard";
import CustomMessage from "../MsUiComponents/CustomMessage";
import CustomVideoCard from "../MsUiComponents/CustomVideoCard";
import CustomSignInCard from "../MsUiComponents/CustomSignInCard";
import Feedback from "../MsUiComponents/Feedback";

export const AttachmentMiddleware =
  (
    api,
    botSettings,
    directLine,
    gid,
    iid,
    addLinks,
    availblityForm,
    servicePopup,
    inZenDesk,
    bookingApp,
    imagedomain,
    parent_location,
    messengerSettings,
    googleAnalytics,
    openCaseForm,
    onStartChat,
    close_confirmed,
    onSingleDislike,
    onMultipleDislikes,
  ) =>
  () =>
  (next) =>
  (card) => {
    switch (card.attachment.contentType) {
      case "application/vnd.microsoft.card.hero":
        return (
          <CustomHeroCard
            herocard={card.attachment.content}
            replyToId={card.activity.replyToId}
            iid={iid}
            conversationId={card.activity.conversation.id}
            messageId={card.activity.id}
            addLinks={addLinks}
            gid={gid}
            api={api}
            googleAnalytics={googleAnalytics}
            directLine={directLine}
            botSettings={botSettings}
            availblityForm={availblityForm}
            servicePopup={servicePopup}
            cardActivitiesSummary={
              card.activity !== undefined && card.activity.summary !== undefined
                ? card.activity.summary
                : ""
            }
            messengerSettings={messengerSettings}
            inZenDesk={inZenDesk}
            bookingApp={bookingApp}
            imagedomain={imagedomain}
            openCaseForm={openCaseForm}
            onStartChat={onStartChat}
            close_confirmed={close_confirmed}
          />
        );
      case "application/vnd.microsoft.card.signin":
        return (
          <CustomSignInCard
            herocard={card.attachment.content}
            replyToId={card.activity.replyToId}
            iid={iid}
            conversationId={card.activity.conversation.id}
            messageId={card.activity.id}
            addLinks={addLinks}
            gid={gid}
            api={api}
            googleAnalytics={googleAnalytics}
            directLine={directLine}
            botSettings={botSettings}
            availblityForm={availblityForm}
            servicePopup={servicePopup}
            cardActivitiesSummary={
              card.activity !== undefined && card.activity.summary !== undefined
                ? card.activity.summary
                : ""
            }
            inZenDesk={inZenDesk}
            bookingApp={bookingApp}
            imagedomain={imagedomain}
          />
        );
      case "ako/file-upload-prompt":
        return <FileUploadCard content={card.attachment.content} api={api} />;
      case "text/markdown":
        let isFinal = false;
        if (
          gid === "73574010-2f33-4b41-8b8a-09d18b025a561" ||
          gid === "5d46a893-e321-4f85-a8bd-b30400535985" ||
          gid === "ca6f18bc-c995-467e-8d88-b2bf01284b9e"
        ) {
          const activity = card?.activity;
          // ✅ safety guards
          if (!activity || activity.type !== "message") {
            return next(card);
          }
          isFinal = activity.channelData?.isFinalBotMessage;
        }
        // ❌ not final message → no feedback
        if (!isFinal) {
          return (
            <CustomMessage
              content={card.attachment.content}
              iid={iid}
              replyToId={card.activity.replyToId}
              conversationId={card.activity.conversation.id}
              messageId={card.activity.id}
              cardActivitiesSummary={
                card.activity !== undefined &&
                card.activity.summary !== undefined
                  ? card.activity.summary
                  : ""
              }
              inZenDesk={inZenDesk}
              location={parent_location}
              googleAnalytics={googleAnalytics}
            ></CustomMessage>
          );
        }

        // ✅ attach feedback only here
        return (
          <div>
            <CustomMessage
              content={card.attachment.content}
              iid={iid}
              replyToId={card.activity.replyToId}
              conversationId={card.activity.conversation.id}
              messageId={card.activity.id}
              cardActivitiesSummary={
                card.activity !== undefined &&
                card.activity.summary !== undefined
                  ? card.activity.summary
                  : ""
              }
              inZenDesk={inZenDesk}
              location={parent_location}
              googleAnalytics={googleAnalytics}
            ></CustomMessage>
            <Feedback
              activityId={card.activity.id}
              gid={gid}
              iid={iid}
              conversationId={card.activity.conversation.id}
              onSingleDislike={onSingleDislike}
              onMultipleDislikes={onMultipleDislikes}
            />
          </div>
        );

      case "application/vnd.microsoft.card.video":
        return (
          <CustomVideoCard
            card={card}
            content={card.attachment.content}
            iid={iid}
            replyToId={card.activity.replyToId}
            conversationId={card.activity.conversation.id}
            messageId={card.activity.id}
            cardActivitiesSummary={
              card.activity !== undefined && card.activity.summary !== undefined
                ? card.activity.summary
                : ""
            }
            inZenDesk={inZenDesk}
          ></CustomVideoCard>
        );
      default:
        return next(card);
    }
  };
